import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

import About from "../Components/SpeacialNeeds/AboutThree";
import NewsLetter from "../Components/SpeacialNeeds/NewsLetter";
import PageBanner from "../Components/PageBanner";
import Platform from "../Components/SpeacialNeeds/Platform";
import TopicsSpecial from "../Components/SpeacialNeeds/TopicsSpecial";
import usePageTracker from "../hooks/usePageTracker";

const SpeacialNeed = () => {
  const { t } = useTranslation(); // Initialize translation
  usePageTracker("page_view_special_needs");

  return (
    <>
      <Helmet>
        <title>{t("seo.special_needs_title")}</title>
        <meta
          name="description"
          content="Learn more about Online Institute, our mission, our team, and the educational values we bring to your learning experience."
        />
        <meta property="og:title" content="About Us | Online Institute" />
        <meta
          property="og:description"
          content="Explore the story and mission of Online Institute — where online education meets excellence and flexibility."
        />
        <meta
          property="og:image"
          content="https://pre-onlineinstitute.mediafactoryworld.com/assets/images/og-image.jpg"
        />
        <meta
          property="og:url"
          content="https://pre-onlineinstitute.mediafactoryworld.com/about"
        />
        <meta name="twitter:title" content="About Online Institute" />
        <meta
          name="twitter:description"
          content="Discover our values, team, and how we deliver quality education to students across the globe."
        />
      </Helmet>
      <PageBanner
        title={t("page_banner.special_needs")}
        pageTitle={t("page_banner.special_needs")}
      />
      <About />
      <TopicsSpecial />
      <Platform />
      <NewsLetter />
    </>
  );
};

export default SpeacialNeed;
